















































































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import {Checkbox, CheckboxGroup, Button, Dialog, Field, Toast} from "vant";
import customField from "@/components/customField/index.vue";
import passwordErrorPrompt from "@/components/passwordErrorPrompt.vue";

const createAccountModule = namespace("createAccount");
const failReasonModule = namespace("failReason");

@Component({
  name: 'ElectronicSign',
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Field.name]: Field,
    [Dialog.Component.name]: Dialog.Component,
    passwordErrorPrompt,
    [customField.name]: customField,
  }
})
export default class ElectronicSign extends Vue {
  @createAccountModule.Getter("signature_photo") signaturePhoto: any;
  @failReasonModule.Mutation("SAVE_MODIFIED_FAIL_REASON")
  saveModifiedFailReason: any;

  result1 = [];
  result2 = [];
  result3 = [];

  checkPassword: string = '';  // 校验登录密码
  checkPasswordShow: boolean = false; // 显示弹出框

  isPhoteShow:boolean = true
  isSubmitDisabledPhoto:boolean = true

  pwdErrPromptOption = {
    show: false,
    errCode: -1,
    errHtml: ''
  }

  get isSubmitDisabled() {
	if(this.isSubmitDisabledPhoto){
		return !(this.signaturePhoto && this.result1.length == 5 && this.result3.length == 2);
	}else {
		return !(this.result1.length == 5 && this.result3.length == 2);
	}
  }

  created(){
    // 
    const _this = this as any;
    let result1 = localStorage.getItem("electronic-sign-result1");
    if(result1){
      result1 = JSON.parse(result1);
      _this.result1 = result1;
      localStorage.removeItem("electronic-sign-result1");
    }
    let result2 = localStorage.getItem("electronic-sign-result2");
    if(result2){
      result2 = JSON.parse(result2);
      _this.result2 = result2;
      localStorage.removeItem("electronic-sign-result2");
    }
    let result3 = localStorage.getItem("electronic-sign-result3");
    if(result3){
      result3 = JSON.parse(result3);
      _this.result3 = result3;
      localStorage.removeItem("electronic-sign-result3");
    }
	 (this as any).$apis.getAccountSituation().then(res =>{
	   if(res.hb_account_status === 0 && res.hk_account_status === 0){
	     (this as any).isPhoteShow = true;
		 (this as any).isSubmitDisabledPhoto = true;
	   } else {
	     (this as any).isPhoteShow = false;
		 (this as any).isSubmitDisabledPhoto = false;
	   }
	 })
  }
  destroyed(){
    const _this = this as any;
    if(_this.result1?.length > 0){
      localStorage.setItem("electronic-sign-result1", JSON.stringify(_this.result1))
    }
    if(_this.result2?.length > 0){
      localStorage.setItem("electronic-sign-result2", JSON.stringify(_this.result2))
    }
    if(_this.result3?.length > 0){
      localStorage.setItem("electronic-sign-result3", JSON.stringify(_this.result3))
    }
  }

  // 路由调整 防止冒泡
  toLink(url: any){
    const _this = this as any;
    _this.$router.push(url);
  }

  dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  handleSaveSignaturePhoto() {
	// if(this.isSubmitDisabledPhoto){
	// 	if (!this.signaturePhoto) return;

	// 	(this as any).$apis.getAccountSituation().then(res =>{
	// 	  if(res.hb_account_status === 0 && res.hk_account_status === 0 && (this as any).$route.query.modify === 1){
	// 	    this.onSubmit()
	// 	  } else {
	// 	    this.checkPasswordShow = true
	// 	  }
	// 	})
	// }else{
	// 	if((this as any).$route.query.modify === 1){
	// 		this.onSubmit()
	// 	} else {
	// 		this.checkPasswordShow = true
	// 	}
	// }

	(this as any).$apis.getAccountSituation().then(res =>{
		if(res.hb_account_status === 0 && res.hk_account_status === 0 ){
			this.onSubmit()
		}else{
			this.checkPasswordShow = true
		}
	})

  }

  beforeClose(action, done) {
    done(false);
  }

  confirm() {
    
    if (this.checkPassword === '') {
      Toast(this.$t('fail_reason.checkPasswordTips'))
    } else {
      (this as any).$apis.checkPasswordFail({
        password: this.checkPassword
      }).then((res: any) => {
        // TODO: 开户-登录错误 Code 100173
        // TODO: 开户-登录错误，冻结 Code 100174
        if(res.code){
          if( res.code === 100174 || res.code === 100173 ){
            this.pwdErrPromptOption.errCode = res.code;
            this.pwdErrPromptOption.errHtml = res.data.err_msg.h5;
            this.pwdErrPromptOption.show = true;
            (this as any).$refs['password-error-prompt-el'].show = true;
            this.checkPasswordShow = false;
            return
          }
        }

        this.checkPasswordShow = false
        this.onSubmit()
      })
    }
  }

  /**
   * 提交
   * */
  onSubmit() {
	if((this as any).isSubmitDisabledPhoto){
		const file = this.dataURLtoFile(this.signaturePhoto, "signature");

		const params = new FormData();
		params.append("file", file);
		params.append("put_dir", "gygjqh_autograph");
		(this as any).$apis
		    .uploadFile(params)
		    .then(res => {
		      const { content } = res;
		      (this as any).$apis
		          .saveSignaturePhoto({
		            open_type: this.$route.query.open_type || 1,
		            autograph_img: content
		          })
		          .then(res => {
		            if (+(this as any).$route.query.account_type === 2) {
		              this.saveModifiedFailReason(7);
		              this.$router.go(-1)
		            } else {
		              this.$router.push("/account-result");
		            }
		          })
		          .catch(e => {
		            
		          });
		    })
		    .catch(e => {
		      
		    });
	} else {
		if (+(this as any).$route.query.account_type === 2) {
		  this.saveModifiedFailReason(7);
		  this.$router.go(-1)
		} else {
		  this.$router.push("/account-result");
		}
	}



  }

  passwordErrorPromptConfirm(errCode){
    (this as any).pwdErrPromptOption.show = false;
    if(errCode === 100173){
      (this as any).checkPasswordShow = true;
      (this as any).$refs['custom-field-password'].setInputFocus();
      setTimeout(() =>{
        (this as any).$refs['custom-field-password'].setInputFocus();
      },500)
    }
  }

}
